module.exports = __webpack_public_path__ + "static/media/liveDrawBottom.575bfc19.png";